import React, { useContext } from 'react';

import { useSelector } from 'react-redux';
import { ConditionalRendering } from '../../../../../components/common/conditional-rendering';
import Tooltip from '../../../../../components/common/tooltip/Tooltip';
import { usePermissions } from '../../../../../hooks/usePermissions';
import { getCurrency } from '../../../../../utils/tools/currencyTools';
import {
    isNotApplicable,
    isNotEqualEffectiveDate,
    isPremiumMonthNotInOrignalEffectiveDate,
    isWithinEffectiveRange,
} from '../../common/enrollmentUtils';
import { IEnrollmentPremiumDto } from '../../common/types';
import { EnrollmentContext } from '../../context/MemberMyEnrollmentProvider';

const ColumnGrossPremium = ({ premium }: { premium: IEnrollmentPremiumDto }) => {
    const permissions = useSelector((state: any) => state.memberEnrollment?.permissions);
    const { userPermissions } = permissions || {};
    const { viewEditableFields } = usePermissions();
    const { enrollmentPremiumFormContext } = useContext(EnrollmentContext);
    const { watch } = enrollmentPremiumFormContext;
    const values = watch();

    return (
        <>
            <ConditionalRendering isTrue={isNotApplicable(premium, values)}>
                <Tooltip
                    id="member.enrollment_list.premiumhistory.notApplicable"
                    elementId="premiumhistory"
                    content="member.enrollment_list.premiumhistory.notApplicable.popup"
                    place="top"
                    dataAutomationId="premiumhistory"
                />
            </ConditionalRendering>
            <ConditionalRendering isTrue={!isNotApplicable(premium, values)}>
                <ConditionalRendering isTrue={viewEditableFields(userPermissions, values, premium)}>
                    {getCurrency(premium.grossPremiumAmount)}
                </ConditionalRendering>
                <ConditionalRendering
                    isTrue={
                        isNotEqualEffectiveDate(values) &&
                        isWithinEffectiveRange(premium.month, values) &&
                        isPremiumMonthNotInOrignalEffectiveDate(premium.month, values)
                    }
                >
                    <Tooltip
                        id="member.enrollment_list.premiumhistory.pendingCalculation"
                        elementId="pendingCalculation"
                        content="member.enrollment_list.premiumhistory.pendingCalculation.popup"
                        place="top"
                        dataAutomationId="pendingCalculation"
                    />
                </ConditionalRendering>
            </ConditionalRendering>
        </>
    );
};

export default ColumnGrossPremium;
